// теперь этот файл/поток будет кодироваться в UTF-8
import app from './App.js';

export { app };